import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  VMAlert,
  VMAlertItem,
  VMAlertTypeCreateRequest,
  VMAlertTypeUpdateRequest,
} from '../model/vm-alert';
import { ImportEntities } from '@/shared/api/import-contracts';

const baseURL = '/api/monitoring/v4/';
const defaultOptions = { baseURL };
export class VMAlertsAPI {
  static getVMAlerts(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<VMAlertItem>>('/vmalerts', {
      ...defaultOptions,
      ...options,
      params,
    });
  }

  static getVMAlertByName(name: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<VMAlert>(`/vmalert/${name}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static createVMAlert(
    payload: VMAlertTypeCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return monitoringInstance.post(`/vmalert`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateVMAlert(
    name: string,
    payload: VMAlertTypeUpdateRequest,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.put(`/vmalert/${name}`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static deleteVMAlert(
    name: string,
    force: boolean = false,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.delete(`/vmalert/${name}`, {
      ...defaultOptions,
      ...options,
      params: { ...options?.params, force },
    });
  }

  static analyzeVMAlertEntities(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/vmalert/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static validateImport(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/vmalert/validate', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static executeVMAlertEntities(
    data: ImportEntities,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post('/import/vmalert/execute', data, {
      ...defaultOptions,
      ...options,
    });
  }

  static exportVMAlerts(vmalert_names: string[], options?: AxiosRequestConfig) {
    return monitoringInstance.get('/vmalert/export/json', {
      ...defaultOptions,
      ...options,
      params: { vmalert_names },

      paramsSerializer: () => {
        const searchParams = new URLSearchParams();
        vmalert_names.forEach((name) =>
          searchParams.append('vmalert_names', name),
        );
        return searchParams.toString();
      },
    });
  }
}